<template>
<div class="wrapper-table">
  <multi-select 
    v-model="table.columns" 
    :options="data.table.columns" 
    optionLabel="label" 
    placeholder="" 
    :filter="true" 
    class="multiselect-columns"
  />

  <dataTable 
    :ref="table.name"
    :value="data.items"
    dataKey="id"

    v-model:selection="data.selectedItems"
    @row-select="onChangeSelectedItems" 
    @row-unselect="onChangeSelectedItems"
    @row-select-all="onChangeSelectedItems"
    @row-unselect-all="onChangeSelectedItems"
    @row-dblclick="openDetail"

    :loading="table.loading"
    sortMode="multiple" 
    responsiveLayout="scroll"

    :paginator="true" 
    :rows="10"
    :rowsPerPageOptions="[10,25,50,500]"
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
    currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"

  >
    <template #header>
      <div >
        <div class="table-header">
          <div class="grid">
            <div class="col-2">
              <i></i><br>
              <prime-button id="filter-button" icon="pi pi-window-maximize" class="p-button"  @click="onButtonFilter($event)"  :disabled="!this.data.selectedItems.length"/>
            </div>
            
            <div class="col p-as-end">
              <form>
                <div class="grid flex align-items-end">
                  <div class="col">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <input-text 
                        v-model="search.text"
                        type="text" 
                        placeholder="Cerca" 
                      />
                    </span>
                  </div>

                  <div class="col">
                    <calendar id="from-date" 
                      v-model="searchFromDate" 
                      :showIcon="true" 
                      placeholder="Da"
                      dateFormat="dd/mm/yy"
                    />
                  </div>

                  <div class="col">
                    <calendar id="to-date" 
                      v-model="searchToDate" 
                      :showIcon="true" 
                      placeholder="A"
                      dateFormat="dd/mm/yy"
                    />
                  </div>

                  <div class="col flex align-items-end">
                      <Checkbox v-model="invoicesNotPay" :binary="true" />
                      <label class="ml-2">Fatture da saldare</label>
                  </div>

                  <div class="col">
                    <i></i><br>
                    <prime-button id="search-button" type="submit" icon="pi pi-search" class="p-button-rounded" @click.prevent="onButtonSearch($event)" />
                  </div>
                </div>
              </form>
            </div>
            <div class="flex align-items-center">
              <i></i><br>
              <prime-button icon="pi pi-download" label="Esporta Dati" @click="exportCSV($event)"
                class="p-button-secondary" />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #empty>
      <div class="box-center">Nessun dato trovato.</div>
    </template>

    <ColumnGroup type="header">
      <Row>
        <column selectionMode="multiple" headerStyle="width: 3em"></column>
        <column 
          v-for="column of table.columns" 
          :field="column.property" 
          :header="column.label" 
          :key="column.property"
          :sortable="column.sortable"
        />
      </Row>
    </ColumnGroup>

    <column selectionMode="multiple" headerStyle="width: 3em"></column>
    
    <column 
      v-for="column of table.columns" 
      :field="column.property" 
      :header="column.label" 
      :key="column.property"
      :sortable="column.sortable"
    >
    
      <template #body="{data}">

        <span v-if="column.type?.isCalculable">
          <div v-if="(data['totale_fattura'] - data['pagato']) == 0" class="closed">
          </div>
          <div v-else class="opened">
          </div>
        </span>

        <span v-if="column.type == null">
          {{ data[column.property] }}
        </span>

        <span v-if="column.type?.isBoolean">
          {{ (data[column.property])? 'SI' : 'NO' }} 
        </span>


        <span v-if="column.type?.isDate">
          {{ (data[column.property] !== null)? moment(data[column.property]).format('DD/MM/YYYY'): '' }}
        </span>

        <span v-if="column.type?.isCurrency">
          {{ currencyFormatter.format( (data[column.property] !== null)? data[column.property] : 0 ) }} 
        </span>
      </template>
    </column> 

    <ColumnGroup type="footer">
        <Row>
            <Column footer="Totali:" :colspan="12" />
            <Column :footer="totalInvoices" />
            <Column :footer="totalPayments" />
            <Column :footer="totalBalance" />
        </Row>
    </ColumnGroup>
    
  </dataTable>
</div>
</template>

<script>
import moment from 'moment'
import { reactive } from 'vue'
import Service from '@/services/ask-management/fatture-acquisto-service'

import PrimeButton from'primevue/button'
import InputText from 'primevue/inputtext'
import Calendar from 'primevue/calendar'
import MultiSelect from 'primevue/multiselect'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  name: 'TableFattureAcquistoDataTable',

  props: {
    intialActiveTabs: {
      type: Array,
      required: true
    },

    initialFilters: {
      type: Object,
      required: true
    }
  },

  emits: ['row-fetched', 'row-selected', 'row-filtered', 'data-searching'],

  components: {
    PrimeButton,
    InputText,
    Calendar,
    MultiSelect,
    DataTable,
    Column,
  },

  data(){
    return {
      moment,

      activeTabs: this.intialActiveTabs,
      filters: this.initialFilters,

      invoicesNotPay: false,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      table: {
        filter_key: 'fattura_acquisto.numeri',
        name: 'fattureAcquistoDataTable',
        loading: false,
        columns: []
      },

      search: {
        text: '',
        fromDate: '',
        toDate: '',
      },

      data: {
        selectedItems: [],

        table:{
          columns: [],
        },

        items: [],
      }
    }
  },


  created() {

    this.service = new Service(this.$http, this.$eventBus)
    this.getAllColumns()

    this.$eventBus.on('active-tabs-changed', (evt) => {
      this.activeTabs = evt.tabs
    })

    this.$eventBus.on('data-filter-changed', (evt) => {

      this.filters = evt.filter

      const filterObject = this.filterObject
      if(filterObject && filterObject.constructor === Object && Object.keys(filterObject).length > 0){
        if( this.activeTabs.includes(this.table.name) ){
          this.getAllItems(this.filterObject)
          this.updateTabSelectedRemovedFromFilter(filterObject)
        }
      }
    })
    
    this.$eventBus.on('data-all-filter-clean', () => {
      this.data.selectedItems = []
      this.filters.items = {}
      this.data.items = []
      this.$emit('row-fetched', {target: this, rows: 0})
    })

    this.$eventBus.on(`update-tab-${this.table.name}`, (items) => {
      items.forEach(item => {
        let index = this.data.items.findIndex(el => el.numero == item.numero);
        this.data.items[index] = item
      });
      this.data.selectedItems = this.data.items    
    })

  },

  methods: {
    openDetail(event) {
      let {data} = event
      if ('id' in data) {
        window.open(`/ask/acquisto/fatture/${data.id}/dettagli`, '_blank')
      } 
    },
    updateTabSelectedRemovedFromFilter(filterObject){
      if (this.table.filter_key in filterObject) {
        this.data.selectedItems = this.data.selectedItems.filter((el) => filterObject[this.table.filter_key].includes(el.numero))
      }
    },
    navigateToTab(href){
      window.open(href, '_blank')
    },

    exportCSV() {
      this.$refs[this.table.name].exportCSV();
    },

    onButtonSearch(/** event **/){
      this.$emit('data-searching', {
        target: this, 
        filter: {
          source: this.table.name,
          target: this.table.name,
          type: 'search',
          items: {
            search: this.search.text,
            from: this.search.fromDate,
            to: this.search.toDate
          }
        },
      })
    },

    onButtonFilter(/** event **/) {
      if (this.data.selectedItems.length) {
        this.$emit('row-filtered', {
          target: this, 
          filter: {
            source: this.table.name,
            target: 'global',
            type: 'filter',
            key: this.table.filter_key,
            items: this.data.selectedItems.map((el) => {
              return {
                key: 'numero',
                value: el.numero,
                label: el.numero,
                item: {...el},
              }
            })
          }
        })
      }
    },

    onChangeSelectedItems(/** event **/) {
      this.$emit('row-selected', {
        target: this, 
        source: this.table.name, 
        items: JSON.parse(JSON.stringify(this.data.selectedItems)),
      })
    },

    getAllItems(opts = {}){

      if (this.invoicesNotPay) {
        opts['only_to_pay'] = true
      }

      for (const [key, value] of Object.entries(this.filters.items)) {
        opts[key] = value
      }

      this.table.loading = true
      this.service.getAllItemsForMindTable(opts).then((res) => {
        this.data.items = res.items
        
        this.$emit('row-fetched', {target: this, rows: res.total})
        this.table.loading = false
      })
    },

    getAllColumns(){
      const allColumns = (this.service.getAllColumnsForMindTable()).map((el) => reactive({...el}))
      const activeColumns = allColumns.filter((el) => el.default)

      activeColumns.forEach((el) => {delete el.default})
      allColumns.forEach((el) => {delete el.default})

      this.data.table.columns = allColumns
      this.table.columns = activeColumns
    },
    formatCurrency(value) {
      return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
    }
  },

  computed: {
    filterObject:{
      get: function() {
        if(this.filters){
          const search = Object.entries(this.filters.searches).filter((el) => {
            if(el[0] === this.table.name){
              return el
            }
          })
          
          if(search.length > 0){
            const searchOBJ = search[0][1]

            return{
              ...searchOBJ
            }
          }

          return {
            ...this.filters.items
          }
        }

        return {}
      }
    },

    searchFromDate: {
      get: function() {
        return (this.search.fromDate !== null && this.search.fromDate !== '')? moment(this.search.fromDate).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.search.fromDate = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.search.fromDate = null
        }
      }
    },
    
    searchToDate: {
      get: function() {
        return (this.search.toDate !== null && this.search.toDate !== '')? moment(this.search.toDate).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.search.toDate = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.search.toDate = null
        }
      }
    },
    totalInvoices: {
      get: function() {
        let total = 0;
        for(let el of this.data.items) {
            total += el.totale_fattura;
        }
        return this.formatCurrency(total);
      },
    },
    totalPayments: {
      get: function() {
        let total = 0;
        for(let el of this.data.items) {
            total += el.pagato;
        }
        return this.formatCurrency(total);
      },
    },
    totalBalance: {
      get: function() {

        let tot_invoices = 0;
        let tot_payments = 0;
        for(let el of this.data.items) {
            tot_invoices += el.totale_fattura;
        }
        for(let el of this.data.items) {
            tot_payments += el.pagato;
        }
        return this.formatCurrency(tot_invoices - tot_payments);
      },
    }
  }
}
</script>

<style scoped>
  .box-center{
    display: flex; 
    align-items: center; 
    justify-content: center;
  }

  .closed {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #00f2db;
  }

  .opened {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fe6b6b;
  }

</style>
